import { useEffect, useState } from 'react'
import { ArrowUpIcon } from '@heroicons/react/24/outline'
function classNames(...classes) {
      return classes.filter(Boolean).join(' ')
}

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)

    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  return (
    <div className="fixed bottom-2 right-2">
      <button
        type="button"
        onClick={scrollToTop}
        className={classNames(
          isVisible ? 'opacity-100' : 'opacity-0',
          ' bg-sky-600  inline-flex items-center rounded-full p-2 text-white shadow-sm transition-opacity focus:outline-none focus:ring-1 focus:ring-offset-1',
        )}
      >
        <ArrowUpIcon className=" h-3 w-3 md:h-5 md:w-5" aria-hidden="true" />
      </button>
    </div>
  )
}